import { DataRoomComputationError as t } from "./DataRoomComputationError.js";
class e extends t {
  constructor(o, r) {
    super(o, r), this.name = "DataRoomComputationOutOfMemoryError";
  }
}
export {
  e as DataRoomComputationOutOfMemoryError
};
//# sourceMappingURL=DataRoomComputationOutOfMemoryError.js.map
